import { ImportAPIPayloadExamplesResponse } from '@ardoq/api-types/integrations';
import { TabType } from './types';

export const formattedJsonString = (s: any) => JSON.stringify(s, null, 2);

export const payloadToFormattedJsonString = (
  activeTab: TabType,
  payload: ImportAPIPayloadExamplesResponse
) => {
  const content =
    activeTab === 'arrays' ? payload.examples.arrays : payload.examples.objects;
  return formattedJsonString(content);
};
